<template>
<div class="page page_order page_order_detail">
    <!-- 物流信息 -->
    <div class="wuliu" v-if="afterSale!=1&&orderDetail.ship_status == 1">
        <div class="wuliu_t">物流信息</div>
        <div class="wuliu_item clearfix" v-for="logistics in orderDetail.logistics" :key="logistics.time">
            <div class="wuliu_item_l f-l">{{ logistics.time }}</div>
            <div class="wuliu_item_r f-l">{{ logistics.description }}</div>
        </div>
        <!-- <div class="wuliu_item clearfix">
            <div class="wuliu_item_l f-l">2020-03-21 20:07</div>
            <div class="wuliu_item_r f-l">河北省衡水市桃城区山木枝有限公司</div>
        </div> -->
    </div>
    <!-- 地址区域 -->
    <div class="item" v-if="afterSale!=1">
        <div class="adress">
            <div class="info">
                <div class="user">{{ orderDetail.receipt_name + ' ' + orderDetail.receipt_phone }}</div>
                <div class="dizhi">
                    {{ orderDetail.receipt_address }}
                </div>
            </div>
        </div>
    </div>
    <!-- 订单商品信息 -->
    <div class="list">
        <div class="item">
            <div class="item_t">
                <div class="item_t_t" v-if="!orderDetail.company_id">
                    <img v-if="orderDetail.tradesman" :src="orderDetail.tradesman.thumb ? ( $publicData.withHttpStart(orderDetail.tradesman.thumb) ? orderDetail.tradesman.thumb : imageUrl+orderDetail.tradesman.thumb) :$publicData.defaultTouxiang" alt="" class="thumb" @click="toTradsman" />
                    <div class="title">{{ (orderDetail.tradesman!=null&&orderDetail.tradesman.nickname!=null)?orderDetail.tradesman.nickname:'' }}</div>
                </div>
				<div class="item_t_t" v-if="orderDetail.company_id">
                    <img :src="orderDetail.company_thumb ? orderDetail.company_thumb : $publicData.defaultTouxiang" alt="" class="thumb" @click="toTradsman" />
                    <div class="title">{{ orderDetail.company_name ? orderDetail.company_name :'' }}</div>
                </div>
                <div v-if="afterSale!=1" class="status">{{ orderDetail.statusTitle }}</div>
                <!-- <div v-if="afterSale==1" class="status" >售后中</div> -->
            </div>
            <div class="item_nr" v-for="goods in orderDetail.order_good" :key="goods.order_good_id">
                <div :class="goods.is_blockchain ? 'item_nr_l blockchain' : 'item_nr_l'" @click="toGoodsDetail(goods)">
                    <img v-if="!orderDetail.company_id" :src="goods.thumb ? imageUrl+goods.thumb : $publicData.intangibleDefault" alt="" class="tu" />
					<img v-if="orderDetail.company_id" :src="goods.thumb ? goods.thumb : $publicData.intangibleDefault" alt="" class="tu" />
				</div>
                <div class="item_nr_r">
                    <div class="item_nr_r_t" @click="toGoodsDetail(goods)">
                        <div class="title slh">
                            {{ goods.title }}
                        </div>
                        <div class="info">
                            <span class="price"><span class="tag_cash">¥</span>{{ goods.price }}</span>
                            <span class="nums">x{{ goods.num }}</span>
                        </div>
                    </div>
                    <div class="sku" @click="toGoodsDetail(goods)">{{ goods.spec_name }}</div>
                    <div class="actions">
                        <div class="action" v-if="orderDetail.madeorderphoto" @click="toKuaizhao(goods)">交易快照</div>
                        <!-- <div v-if="!goods.return_good_info && orderDetail.receipt_status==1 && type != 1 && goods.tx_status != 1" class="action" @click="goTuiKuan(goods)" >申请退换</div> -->
                        <div class="action" v-if="!orderDetail.company_id && orderDetail.pay_status == 2 && show_cancel_status" @click="goTuiKuan(goods)">{{ goods.status == 1 ? '查看退换' : '申请退换' }}</div>
                        <div v-if=" !orderDetail.company_id &&!goods.return_good_info&&orderDetail.receipt_status==1&&goods.comment_status==0" class="action" @click="goComment(goods)">评价</div>
                        <div v-if="!orderDetail.company_id && !goods.return_good_info&&orderDetail.receipt_status==1&&goods.comment_status==1" class="action">已评价</div>
                        <!-- <div v-if="goods.return_good_info && type != 1" class="action" >{{goods.return_good_info.status==0?'退款中':(goods.return_good_info.status==1?'退款成功':'退款失败')}}</div> -->
                    </div>
                </div>
            </div>
            <div class="item_extra">
                <div class="item_extra_l">邮费</div>
                <div class="item_extra_r">{{ orderDetail.fare }}</div>
            </div>
            <div class="item_extra" v-if="discount && discount != 0">
                <div class="item_extra_l">折扣</div>
                <div class="item_extra_r">{{ dazhe }}</div>
            </div>
            <!-- 已支付的 显示实付款 -->
            <div v-if="orderDetail.pay_status == 2">
				<div>
					<div class="item_extra shifu" v-if="orderDetail.pay_name.indexOf('i一起支付') != -1">
						<span class="shifu_item">{{'i一起积分抵扣: ' + orderDetail.total_prices }}</span>
					</div>
					<div v-else>
						<div class="item_extra shifu" v-if="dikouObj.user_money || dikouObj.chargecard  || dikouObj.parkscore_money && dikouObj.parkscore_money != 0 && dikouObj.points_exchange_moneys != 0">
							<span class="shifu_item" v-if="dikouObj.user_money && dikouObj.user_money != 0">{{'余额抵扣: ' + dikouObj.user_money }}</span>
							<span class="shifu_item" v-if="dikouObj.chargecard && dikouObj.chargecard != 0">{{'充值卡抵扣: ' + dikouObj.chargecard }}</span>
							<span class="shifu_item" v-if="dikouObj.parkscore_money && dikouObj.parkscore_money != 0">{{ '园区积分抵扣: ' + dikouObj.parkscore_money }}</span>
							<span class="shifu_item" v-if="dikouObj.points_exchange_moneys && dikouObj.points_exchange_moneys != 0">{{ '平台积分抵扣: ' + dikouObj.points_exchange_moneys }}</span>
						</div>
					</div>
				</div>
                <div class="item_extra">
                    <div class="item_extra_l">实付款</div>
                    <div class="item_extra_r">
                        <div class="price"><span class="cash_tag">¥</span>{{ shifuPrice }}</div>
                    </div>
                </div>
            </div>
            <!-- 未支付成功的 显示应付款 -->
            <div class="item_extra" v-if="orderDetail.pay_status != 2">
                <div class="item_extra_l">应付款</div>
                <div class="item_extra_r">
                    <div class="price"><span class="cash_tag">¥</span>{{ orderDetail.total_prices }}</div>
                </div>
            </div>
        </div>
        <!-- 订单信息 -->
        <div class="item item_order">
            <div class="title">订单信息</div>
            <div class="order">
                <div class="">订单编号:{{ orderDetail.order_num }}</div>
                <div class="">父订单编号:{{ orderDetail.pay_order_num }}</div>
                <div class="">创建时间:{{ orderDetail.created_at }}</div>
                <div class="" v-if="orderDetail.pay_at">付款时间:{{ orderDetail.pay_at }}</div>
                <!-- <div class="return" v-if="orderDetail.order_status==3" >您好，退款金额将在3-5个工作日退回到您的原支付账户内，请您耐心等待。</div> -->
            </div>
        </div>
        <!-- 操作 -->
        <div class="actions">
            <div class="action" v-if="!orderDetail.company_id && role != 1" @click="toServer">联系匠人</div>
            <div class="action" v-if="(orderDetail.order_status!=0&&orderDetail.pay_status==0) || (orderDetail.order_status!=0&&orderDetail.pay_status==1)" @click="toPay">付款</div>
            <!-- orderDetail.order_status!=0&&orderDetail.ship_status!=1 -->
            <div class="action" v-if="!orderDetail.company_id && orderDetail.order_status!=0&&orderDetail.pay_status!=2" @click="cancelOrder">取消订单</div>
            <div class="action" v-if="orderDetail.order_status!=0&&orderDetail.pay_status==2 && orderDetail.pay_name.indexOf('i一起支付') != -1 && show_cancel_status == 0" @click="showIyiqi = true">取消订单</div>
            <div class="action" v-if="orderDetail.order_status!=0&&orderDetail.ship_status==1&&orderDetail.receipt_status==0 && type != 1 && role!=1" @click="clickReceipt">收货</div>
            <div class="action" v-if="orderDetail.order_status!=0&&orderDetail.ship_status==1&&orderDetail.receipt_status==0 && type==1" @click="show_overlay = true">提货码</div>
        </div>
        <!-- 提货码 -->
        <van-overlay :show="show_overlay" @click="show_overlay = false" />
        <div class="custom_info" v-if="show_overlay">
            <div class="info_top">
                <div class="info_title">提货凭证</div>
                <img :src="publicPath+'statics/images/close_item.png'" alt="" class="info_close" @click="show_overlay = false">
            </div>
            <div class="info_nr" v-if="orderDetail.zt">
                <div class="tu_wrap">
                    <img :src="publicPath+'statics/images/ziti_bg.png'" alt="" class="tu">
                </div>
                <div class="num_wrap">
                    <div class="num_title">提货码</div>
                    <div class="nums">{{orderDetail.zt.tihuocode}}</div>
                </div>
                <div class="text">
                    <div class="text_info">
                        <div class="text_info_l">提货手机：</div>
                        <div class="text_info_r">{{orderDetail.zt.phone}}</div>
                    </div>
                    <div class="text_info zitidian">
                        <div class="text_info_l">自提点：</div>
                        <div class="text_info_r">{{orderDetail.zt.name}}</div>
                    </div>
                    <div class="text_info address">
                        <div class="text_info_l">提货地址：</div>
                        <div class="text_info_r">{{ orderDetail.zt.address }}</div>
                    </div>
                </div>
            </div>
        </div>
        <!-- i一起确认弹框 -->
        <van-overlay :show="showIyiqi">
            <div class="sec-confirm">
                <div class="confirm-name">此订单关联多个订单，请确认是否取消？</div>
                <div class="confirm-actions">
                    <div class="confirm-btn ac-cancle" @click="showIyiqi = false">再想想</div>
                    <div class="confirm-btn" @click="cancelIyiqiOrder">确认</div>
                </div>
            </div>
        </van-overlay>
    </div>
</div>
</template>

<script>
import Vue from "vue";
import router from "../../../../../.././router";
import {
    LOGOUT,
    LOGIN
} from "../../../../../.././vuex/mutation_types";
import Bridge from "../../../../../.././vuex/bridge.js";
Vue.prototype.$bridge = Bridge;
var userAgent = navigator.userAgent;
export default {
    data() {
        return {
            publicPath: process.env.BASE_URL,
            imageUrl: this.$publicData.uploadImage,
            orderId: this.$route.query.orderId,
            afterSale: this.$route.query.afterSale, // 是否售后
            orderDetail: {},
            token: null,
            type: this.$route.query.type, // 1自提订单, 默认普通订单
            show_overlay: false, // 遮罩层状态
            role: this.$route.query.role, // 1 商家角色, 0 普通角色
            discount: null, // 折扣
            dazhe: null, // 打几折
            dikouObj: { // 每种支付方式支付多少钱
                user_money: 0,
                chargecard: 0,
                parkscore_money: 0
            },
            shifuPrice: null, // 实付价格
            show_cancel_status: null, // i一起积分支付的订单, 申请退换 1显示 0不显示
            showIyiqi: false, // i一起确认弹框
            needUpdate: false // 是否做了取消、发货、支付等操作,有就得给订单列表指令去更新
        };
    },
    created: function () {

    },
    mounted: function () {
        if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
            //修改导航栏样式
            var styleParams = {
                'data': {
                    'naviTitle': '订单详情',
                }
            }
            this.$bridge.callhandler('sdjy://navigation/style', styleParams, (data) => {

            })
            //获取用户信息
            var memberParams = {
                'data': {}
            }
            this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                if (data.code == 200) {
                    this.token = data.result.token
                    this.getData()
                }
            })
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler('sdjy://common/refreshPage', (data, responseCallback) => {
                // alert(JSON.stringify(data));
                this.getData()
                responseCallback(data)
            })
        } else {
            this.token = this.$store.getters.token
            // 获取列表
            this.getData();
        }
    },
    methods: {
        // 获取列表
        getData() {
            var params = {
                token: this.token,
                order_id: this.orderId
            }
            this.$api.shop.orderDetail(params).then(res => {
                if (res.code == 200) {
                    this.orderDetail = res.result;
                    this.show_cancel_status = res.result.show_cancel_status;
                    // 折扣 有折扣!= 0
                    this.discount = res.result.discount
                    var discount = res.result.discount
                    if (discount && discount != 0) {
                        var discount = discount.toString()
                        var zhe = ''
                        if (discount.length == 1) {
                            zhe = discount / 10 + '折'
                        } else if (discount.length > 1) {
                            if (discount[discount.length - 1] == 0) {
                                zhe = discount / 10 + '折'
                            } else {
                                zhe = discount + '折'
                            }
                        }
                        this.dazhe = zhe
                    }
                    // 订单状态 0关闭 1正常 2完成 3退款中
                    if (this.orderDetail.order_status == 0) {
                        if (this.orderDetail.pay_status == 2) {
                            this.orderDetail.statusTitle = '已退款'
                        } else {
                            this.orderDetail.statusTitle = '已取消'
                        }
                    } else if (this.orderDetail.order_status == 3) {
                        this.orderDetail.statusTitle = '退款中'
                    } else if (this.orderDetail.receipt_status == 1) {
                        this.orderDetail.statusTitle = '交易成功'
                    } else {
                        if (this.orderDetail.ship_status == 1) {
                            this.orderDetail.statusTitle = this.type == 1 ? '待提货' : '等待收货'
                        } else {
                            if (this.orderDetail.pay_status == 0) {
                                this.orderDetail.statusTitle = '等待付款'
                            } else if (this.orderDetail.pay_status == 1) {
                                this.orderDetail.statusTitle = '等待付款'
                            } else if (this.orderDetail.pay_status == 2) {
                                this.orderDetail.statusTitle = '等待发货'
                            }
                        }
                    }
                    // 获取支付信息，每种支付方式支付多少钱
                    this.getUsedMoney(res.result.pay_order_num)
                } else {
                    this.$toast(res.message)
                }
            })
        },
        //点击头像进入匠人详情页或供应商详情
        toTradsman() {
            var sellerUrl = this.$publicData.clientUrl + '/seller/detail?sellerId=' + this.orderDetail.tradesman.id
            var shopUrl = this.$publicData.clientUrl + '/art/detail?tradesmanId=' + this.orderDetail.tradesman.id
            var ulr = this.orderDetail.is_platprice == 1 ? sellerUrl : shopUrl
            if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                var params = {
                    'data': {
                        'url': url
                    }
                }
                this.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

                })
            } else {
                if (this.orderDetail.is_platprice == 1) {
                    this.$router.push({
                        path: '/seller/detail',
                        query: {
                            sellerId: this.orderDetail.tradesman.id
                        }
                    })
                } else {
                    this.$router.push({
                        path: '/art/detail',
                        query: {
                            tradesmanId: this.orderDetail.tradesman.id
                        }
                    })
                }

            }
        },
        //点击商品进入商品详情页
        toGoodsDetail(goods) {
            if (userAgent && userAgent.indexOf("shidaijiyi") != -1) {
                var p = "?goodsId=" + goods.good_id;
                var params = {
                    data: {
                        url: this.$publicData.clientUrl + "/shop/detail" + p
                    },
                };
                this.$bridge.callhandler(
                    "sdjy://public/openNewWebView",
                    params,
                    (data) => {}
                );
            } else {
                this.$router.push({
                    path: "/shop/detail",
                    query: {
                        goodsId: goods.good_id,
                    },
                });
            }
        },
        //收货
        clickReceipt() {
            var params = {
                token: this.token,
                order_id: this.orderId
            }
            if (this.orderDetail.is_cloud == 1) {
                // 云支付 收货
                this.$api.shop.confirmOrderYun(params).then(res => {
                    if (res.code == 200) {
                        this.needUpdate = true;
                        this.$toast('确认收货成功')
                        this.getData()
                    } else {
                        this.$toast(res.message)
                    }
                })
            } else {
                // 商城 收货
                this.$api.shop.confirmOrder(params).then(res => {
                    if (res.code == 200) {
                        this.needUpdate = true;
                        this.$toast('确认收货成功')
                        this.getData();
                    } else {
                        this.$toast(res.message)
                    }
                })
            }

        },
        // 申请退换
        goTuiKuan(goods) {
            // 先判断退款状态
            let params = {
                token: this.token,
                ordergood_id: goods.order_good_id
            }
            this.$api.shop.returnstatus(params).then(res => {
                if (res.code == 200) {
                    let return_id = res.result; // res.result
                    if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                        var p = '?orderId=' + goods.order_good_id + '&returnId=' + return_id + '&shipStatus=' + this.orderDetail.ship_status
                        var url = this.$publicData.clientUrl + '/order/tuikuan/index' + p
                        console.log(url)
                        // url = this.encodeUtf8(url)
                        // url = encodeURIComponent(url)
                        // console.log(url)
                        var queryparams = {
                            'data': {
                                'url': url
                            }
                        }
                        this.$bridge.callhandler('sdjy://public/openNewWebView', queryparams, (data) => {

                        })
                    } else {
                        this.$router.push({
                            path: '/order/tuikuan/index',
                            query: {
                                orderId: goods.order_good_id,
                                returnId: return_id,
                                shipStatus: this.orderDetail.ship_status
                            }
                        })
                    }
                } else if (res.code == 202) {
                    // 202：确认收货后15天 弹框提示商品超过售后期，请直接联系商家
                    this.$toast("商品超过售后期，请直接联系商家")
                } else {
                    this.$toast(res.message)
                }
            })
        },
        // 评论
        goComment(goods) {
            if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                var p = "?orderId=" + this.orderDetail.order_id + '&goodsId=' + goods.good_id
                // + '&title=' + encodeURIComponent(goods.title) + '&price=' + goods.total_prices + '&count=' + goods.num + '&spec=' + encodeURIComponent(goods.spec_name) + '&image=' + goods.thumb
                var params = {
                    'data': {
                        'url': this.$publicData.clientUrl + '/order/comment' + p
                    }
                }
                this.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

                })
            } else {
                this.$router.push({
                    path: '/order/comment',
                    query: {
                        orderId: this.orderDetail.order_id,
                        goodsId: goods.good_id,
                        // title: goods.title,
                        // price: goods.total_prices,
                        // count: goods.num,
                        // spec: goods.spec_name,
                        // image: goods.thumb
                    }
                })
            }
        },
        toPay() {
            if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                var p = "?orderId=" + this.orderDetail.pay_order_num + '&price=' + this.orderDetail.total_prices + '&sorce=' + this.orderDetail.is_cloud + '&park_point=' + this.orderDetail.user_park_point + '&duihuan_money=' + this.orderDetail.user_duihuan_money + '&pay_status=' + this.orderDetail.pay_status + '&park_uuid=' + this.orderDetail.park_uuid
                var params = {
                    'data': {
                        'url': this.$publicData.clientUrl + '/shop/pay' + p
                    }
                }
                this.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

                })
            } else {
                this.$router.push({
                    path: '/shop/pay',
                    query: {
                        orderId: this.orderDetail.pay_order_num,
                        price: this.orderDetail.total_prices,
                        isPlatprice: this.orderDetail.company_id ? 1 : this.orderDetail.is_platprice,
                        sorce: this.orderDetail.is_cloud,
                        park_point: this.orderDetail.user_park_point,
                        duihuan_money: this.orderDetail.user_duihuan_money,
                        pay_status: this.orderDetail.pay_status,
                        park_uuid: this.orderDetail.park_uuid,
                        thirdJifenBili: this.orderDetail.score_rule
                    }
                })
            }

        },
        cancelOrder() {
            // console.log('show_cancel_status',this.show_cancel_status)
            if (!this.show_cancel_status) {
                this.showIyiqi = true;
                return;
            };
            let params = {
                token: this.token,
                order_id: this.orderId
            }
            this.$api.shop.cancelOrder(params).then(res => {
                if (res.code == 200) {
                    this.$toast('取消订单成功');
                    this.needUpdate = true;
                    this.getData();
                } else {
                    this.$toast(res.message)
                }
            })
        },
        /**
         * @name: 取消i一起积分支付的订单
         * @return {*}
         * @desc: 
         */
        cancelIyiqiOrder() {
            let params = {
                token: this.token,
                order_id: this.orderId
            }
            this.$api.shop.canceliyiqiorder(params).then(res => {
                if (res.code == 200) {
                    this.$toast('取消订单成功');
                    this.needUpdate = true;
                    this.showIyiqi = false;
                    this.getData()
                } else {
                    this.$toast(res.message)
                }
            })
        },
        // 提货码
        clickZiti() {
            console.log('提货码')
        },
        toServer() {
            var that = this;
            if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                var memberParams = {
                    data: {},
                };
                this.$bridge.callhandler("sdjy://member/memberInfo", memberParams, (data) => {
                    if (data.code == 200) {
                        var token = data.result.token;
                        // console.log(that.info.tradesman)
                        var params = {
                            token: token,
                            uuid: that.orderDetail.tradesman.uuid
                        };
                        that.$api.xiaoxi.userInfo(params).then(res => {
                            if (res.code == 200) {
                                var tradesmanInfo = res.result;
                                // console.log('创建了与匠人的通信')
                                // that.$parent.sendMsgToTradesman('与' + that.tradesmanInfo.username + '建立了通信', that.mine.userId, that.tradesmanInfo.im_username);

                                that.toAppServe(tradesmanInfo);
                            }
                        })
                        // that.toAppServe(that.info.tradesman)
                    }
                });
            } else {

                if (!that.$store.getters.token) {
                    localStorage.setItem('redirect', that.$router.currentRoute.fullPath)
                    that.$router.push({
                        path: '/login',
                    })
                    return
                }
                console.log(that.data)
                that.$router.push({
                    path: '/tradesman/chat',
                    query: {
                        uuid: that.orderDetail.tradesman.uuid
                    }
                })
            }
        },
        toAppServe(tradesmanInfo) {
            var params = {
                data: {
                    toId: tradesmanInfo.im_username,
                    conversationId: tradesmanInfo.im_username,
                    toAvator: tradesmanInfo.tradesmans.thumb,
                    toName: tradesmanInfo.tradesmans.nickname,
                    toUUID: tradesmanInfo.tradesmans.uuid,
                    trandsmanId: tradesmanInfo.tradesmans.id
                },
            }
            console.log('params:', params)
            this.$bridge.callhandler("sdjy://public/chat", params, (data) => {

            });
        },
        // 获取支付信息 获取支付信息，每种支付方式支付多少钱
        getUsedMoney(orderNum) {
            var params = {
                token: this.token,
                pay_order_num: orderNum
            }
            this.$api.shop.paymoney(params).then(res => {
                if (res.code == 200) {
                    var dikou = res.result
                    var total_prices = res.result.total_prices // 实际价格
                    // console.log('total_prices',total_prices);
					if(this.orderDetail.pay_name.indexOf('i一起支付') != -1){
						this.shifuPrice = 0;
					}else{
						this.shifuPrice = (total_prices - dikou.chargecard - dikou.user_money - dikou.parkscore_money - dikou.points_exchange_moneys).toFixed(2)
						// console.log('shifuPrice',this.shifuPrice)
						this.dikouObj = dikou
					}
                }
            })
        },
        // 交易快照
        toKuaizhao(goods) {
            this.$router.push({
                path: "/order/kuaizhao",
                query: {
                    orderId: this.orderId,
                    goodsId: goods.good_id
                }
            })
        }
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.orderListStatus = to.query.status;
            vm.needUpdate = false;
        })
    },
    beforeRouteLeave(to, from, next) {
        to.query.status = this.orderListStatus;
        if (this.needUpdate) {
            to.meta.isrefer = true;
        } else {
            to.meta.isrefer = false;
        }
        next();
    },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
.sec-confirm {
    width: 8rem;
    border-radius: .4rem;
    background: #ffffff;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    padding: .4rem;
}

.sec-confirm .confirm-name {
    font-size: .4rem;
    text-align: center;
}

.sec-confirm .confirm-actions {
    display: flex;
    align-items: center;
    justify-content: space-around;
    margin-top: 0.4rem;
    font-size: .38rem;
}

.sec-confirm .confirm-actions .confirm-btn {
    width: 2.67rem;
    height: 0.93rem;
    border-radius: 0.47rem;
    font-size: 0.4rem;
    text-align: center;
    line-height: 0.93rem;
    color: rgba(255, 255, 255, 1);
    background: linear-gradient(90deg, rgba(223, 52, 52, 1), rgba(255, 95, 52, 1));
}

.sec-confirm .confirm-actions .confirm-btn.ac-cancle {
    background: rgba(0, 0, 0, .2);
}

.sec-confirm .beizhu-wrap {
    display: flex;
    align-items: flex-end;
    height: 0.77rem;
    line-height: 0.77rem;
    margin-top: 0.2rem;
}

.sec-confirm .beizhu-wrap .van-cell {
    width: auto;
    padding: 0;
    line-height: unset;
    border-bottom: 0.0134rem solid rgba(0, 0, 0, .1);
}
</style>
